import React, { lazy, Suspense, useState } from "react";
import { CommonModal } from "../../shared/Components/Modal";
import { SubHeading } from "../../shared/Components";
import { getAxios } from "../../shared/Services/commonService";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { API_WHITELABEL } from "../../utils/api/ApiConstant";
import WhiteLabelModal from "../../shared/Components/Modal/ConfigurationModal/WhiteLabelModal";

const WhitelabelBody = lazy(() => import("./WhitelabelBody"));
const Whitelabel = () => {
  const LoggedInUserId = useSelector((state) => state.user?.user?.id);

  const {
    data,
    isLoading,
    refetch: whitelabelRefetch,
  } = useQuery({
    queryKey: ["whitelabelData", LoggedInUserId],
    queryFn: () => getAxios(API_WHITELABEL),
    enabled: !!LoggedInUserId,
  });

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const handleModal = (rowData, title = "") => {
    setIsShow({
      isOpen: true,
      modalContent: WhiteLabelModal,
      modalTitle: title,
      rowData,
    });
  };

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <WhitelabelBody
          onEdit={(rowData) => handleModal(rowData, "Edit")}
          data={data}
          isLoading={isLoading}
          fetchData={whitelabelRefetch}
        />
      </Suspense>

      {isShow?.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          size="sm"
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
              fetchData: whitelabelRefetch,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Whitelabel;
